<div class="info-stocks">
	@switch (activeTab()) {
		@case (infoStocksTabEnum.DESCRIPTION) {
			<app-info-stocks-description [liveTicker]="liveTicker()" />
		}
		@case (infoStocksTabEnum.STATISTICS) {
			<app-info-stocks-statistics [liveTicker]="liveTicker()" />
		}
		@case (infoStocksTabEnum.ANALYTICS) {
			<app-info-stocks-analytics
				[liveTicker]="liveTicker()"
				[widget]="widget()"
			/>
		}
	}
</div>
